import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> toode

  <span style="color:#85c1dc;">**FI:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> tuote

  <span style="color:#85c1dc;">**RU:**</span>
  <span style="color:#a6d189;">**{quantity}**</span> товар
*/
/* @__NO_SIDE_EFFECTS__ */
const m32 = msg(
  mf`${'quantity'} toode`,
  mf`${'quantity'} tuote`,
  mf`${'quantity'} товар`,
)

export { m32 as 'w.basket.products_in_basket' }